<template>
  <div>
    <px-view-header title="Cadastro de fornecedor"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div>
      <v-row dense>
        <v-col cols="12" sm="4" md="4">
          <px-select-enum
            dense
            required
            :disabled="loading"
            class="required rounded-tag-small"
            label="Categoria do fornecedor"
            :items="tiposFornecedor"
            v-model="fornecedor.tipo"
            @change="onChangeTipo"/>
        </v-col>
        <v-col cols="12" sm="4" md="4" v-if="isFornecedorOutros">
          <px-select-enum
            dense
            required
            :disabled="loading"
            class="required rounded-tag-small"
            label="Tipo de fornecedor"
            :items="tiposFilhoFornecedor"
            v-model="fornecedor.tipoFilho"
            @change="onChangeTipo"
          />
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field
            ref="documento"
            dense
            outlined
            hide-details
            :disabled="loading"
            :class="classDocumento"
            :label="labelDocumento"
            v-mask="mask"
            :error="$v.fornecedor.documento.$error"
            @blur="$v.fornecedor.documento.$touch()"
            v-model="fornecedor.documento"
          />
        </v-col>
      </v-row>
      <div>
        <px-cadastro-fornecedor-nacional v-if="showCadastroNacional"
                                         :fornecedor="fornecedor"
                                         @loading="onLoadingCadastro"/>
        <px-cadastro-fornecedor-outros v-if="isFornecedorOutros"
                                       :fornecedor="fornecedor"
                                       @before-save="onBeforeSave"/>
      </div>
    </div>
  </div>
</template>

<script>
import CadastroFornecedorNacional
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorNacional.vue';
import CadastroFornecedorOutros
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorOutros.vue';
import { TipoFornecedor } from 'px-business-components';
import { isValid } from '@/utils/validate-cnpj';
import { isValid as isValidCpf } from '@/utils/validate-cpf';
import { requiredIf } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Cadastros' },
        { text: 'Fornecedores' },
      ],
      loading: false,
      tiposFornecedor: TipoFornecedor.values,
      tiposFilhoFornecedor: TipoFornecedor.childValues,
      fornecedor: {
        tipo: TipoFornecedor.keys.NACIONAL.key,
        documento: null,
        tipoFilho: TipoFornecedor.keys.INTERNACIONAL.key,
      },
    };
  },
  computed: {
    showCadastroNacional() {
      return this.isFormValid && this.isFornecedorNacional;
    },
    isFornecedorOutros() {
      return this.fornecedor.tipo === TipoFornecedor.keys.EXTERIOR.key;
    },
    isFornecedorNacional() {
      return this.fornecedor.tipo === TipoFornecedor.keys.NACIONAL.key;
    },
    isPessoaFisica() {
      return this.fornecedor.tipoFilho === TipoFornecedor.keys.PESSOA_FISICA.key;
    },
    isFormValid() {
      return !this.$v.$invalid;
    },
    mask() {
      if (this.isFornecedorOutros && this.isPessoaFisica) {
        return ['###.###.###-##'];
      }
      return this.isFornecedorNacional ? ['##.###.###/####-##'] : ['XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'];
    },
    labelDocumento() {
      if (this.isFornecedorOutros && this.isPessoaFisica) {
        return 'CPF';
      }
      return this.isFornecedorNacional ? 'CNPJ' : 'Documento';
    },
    classDocumento() {
      if (this.isFornecedorOutros && this.isPessoaFisica) {
        return 'required rounded-tag-small';
      }
      return this.isFornecedorNacional ? 'required rounded-tag-small' : 'rounded-tag-small';
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.gestao-fornecedores.fornecedores' });
    },
    onChangeTipo() {
      // limpando o componente diretamente aqui. O v-mask impede que o v-model faça isso :D
      this.$refs.documento.$el.getElementsByTagName('input')[0].value = '';
      this.fornecedor.documento = null;
    },
    onLoadingCadastro(loading) {
      this.loading = loading;
    },
    onBeforeSave() {
      this.validateForm();
    },
  },
  components: {
    pxCadastroFornecedorNacional: CadastroFornecedorNacional,
    pxCadastroFornecedorOutros: CadastroFornecedorOutros,
  },
  validations: {
    fornecedor: {
      documento: {
        requiredIf: requiredIf(
          value => value.tipo === TipoFornecedor.keys.NACIONAL.key,
        ),
        validateCnpj(value, context) {
          if (context.tipo === TipoFornecedor.keys.EXTERIOR.key) {
            return this.isPessoaFisica ? isValidCpf(value) : true;
          }
          return isValid(value);
        },
      },
    },
  },
};
</script>
